import { AlertTriangle, Clock } from 'lucide-react'
import { formatDistanceToNow, differenceInDays } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { useAuth } from '@/contexts/AuthContext'

/**
 * Pill flutuante no canto inferior direito quando tenant está:
 *   - suspended (bloqueio admin — mutations devem falhar)
 *   - trialing com < 3 dias restantes (warning suave)
 *
 * Impersonation/GodMode (z-[60]/[55]) tomam precedência; esta pill fica
 * logo acima delas (z-[50]) com offset adicional quando coexistem.
 */
export default function TenantStatusBanner() {
  const { profile, impersonating, isPlatformAdmin } = useAuth()
  if (!profile?.tenant) return null
  const tenant = profile.tenant

  // Empilha acima das outras banners quando estiverem presentes, e respeita
  // a variável --mobile-bottom-bar-pad que páginas com bottom action bars
  // setam pra empurrar banners pra cima e evitar sobreposição em mobile.
  const hasOtherBanner = impersonating || (isPlatformAdmin && profile.tenant && typeof window !== 'undefined' && !/^admin(-dev)?\./.test(window.location.hostname))
  const bottomStyle: React.CSSProperties = {
    bottom: hasOtherBanner
      ? 'calc(76px + var(--mobile-bottom-bar-pad, 0px))'
      : 'calc(1rem + var(--mobile-bottom-bar-pad, 0px))',
  }

  if (tenant.status === 'suspended') {
    return (
      <div
        className="fixed right-4 z-[50] flex items-center gap-2 px-3 py-2 rounded-full shadow-lg max-w-[calc(100vw-2rem)]"
        style={{ background: 'var(--color-danger)', color: 'white', ...bottomStyle }}
      >
        <AlertTriangle className="w-3.5 h-3.5 shrink-0" />
        <span className="text-[11.5px] font-semibold truncate">
          Acesso suspenso — contate o administrador
        </span>
      </div>
    )
  }

  if (tenant.status === 'trialing' && tenant.trial_ends_at) {
    const daysLeft = differenceInDays(new Date(tenant.trial_ends_at), new Date())
    if (daysLeft <= 3) {
      return (
        <div
          className="fixed right-4 z-[50] flex items-center gap-2 px-3 py-2 rounded-full shadow-lg max-w-[calc(100vw-2rem)]"
          style={{ background: 'var(--color-warning)', color: '#3d2400', ...bottomStyle }}
        >
          <Clock className="w-3.5 h-3.5 shrink-0" />
          <span className="text-[11.5px] font-semibold truncate">
            Trial termina {formatDistanceToNow(new Date(tenant.trial_ends_at), { addSuffix: true, locale: ptBR })}
          </span>
        </div>
      )
    }
  }

  return null
}
